<mat-form-field *ngIf="this.fControl"
                appearance="outline"
                class="w-100 date-input"
                [ngClass]="{'has-content':this.fControl && this.fControl.value, 'input_date_required': required != ''}">

  <mat-label class="input-label"> {{label}} </mat-label>

  <input autocomplete="off"
         matInput
         maxlength="10"
         #dateInput
         [value]="dateformat"
         [disabled]="fControl.disabled"
         (keyup)="formatDate(dateInput, $event)" />

  <input matInput
         style="display: none;"
         [formControl]="fControl" />

  <mat-icon class="buttonclear"
            style="cursor: pointer;"
            *ngIf="dateformat"
            (click)="clearDate()"
            matSuffix>clear
  </mat-icon>
</mat-form-field>
